import axios from "axios";


export const fetchBedApiCall = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Bed`);

}

export const postBedApiCall =(body) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/Bed`, body);

}
